<template>
  <div>
    <div class="subtitle-2 font-weight-medium text-uppercase mb-3">Cell Wise</div>
    <v-select
      v-model="cell"
      :items="cells"
      label="Select Cell"
      outlined
      dense
      clearable
      hide-details
      no-data-text="No data available"
    ></v-select>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

const STORAGE_KEY = 'cellwiseProduction_selectedCell';

export default {
  name: 'CellWiseFilter',
  data() {
    return {
      cell: this.$route.query.selectedcell || this.$route.query.cellname || '',
    };
  },
  computed: {
    ...mapState('cellwiseProductionDashboard', ['machines']),
    routeCell() {
      return this.$route.query.selectedcell || this.$route.query.cellname || '';
    },

    cells() {
      if (!this.machines || !Array.isArray(this.machines) || this.machines.length === 0) {
        return [];
      }

      // Extract the cells
      const allCells = this.machines
        .map((m) => m.machinecell)
        .filter((c) => c && c.trim() !== '');

      const uniqueCells = [...new Set(allCells)].sort();

      return uniqueCells;
    },
  },
  methods: {
    ...mapMutations('cellwiseProductionDashboard', ['setSelectedCell']),
    syncCellSelection(value) {
      const query = { ...this.$route.query };

      if (value) {
        query.selectedcell = value;
      } else {
        delete query.selectedcell;
      }

      this.setSelectedCell(value);

      if (this.$route.query.selectedcell !== value) {
        this.$router.push({ query }).catch(() => {});
      }
    },
  },
  watch: {
    cells: {
      immediate: true,
      handler(newCells) {
        if (newCells && newCells.length > 0) {
          const { routeCell } = this;
          const storedCell = localStorage.getItem(STORAGE_KEY);
          let preferredCell = newCells[0];

          if (routeCell && newCells.includes(routeCell)) {
            preferredCell = routeCell;
          } else if (storedCell && newCells.includes(storedCell)) {
            preferredCell = storedCell;
          }

          if (this.cell !== preferredCell) {
            this.cell = preferredCell;
          }

          if (preferredCell) {
            localStorage.setItem(STORAGE_KEY, preferredCell);
          } else {
            localStorage.removeItem(STORAGE_KEY);
          }
        }
      },
    },
    routeCell(newCell) {
      if (newCell !== this.cell) {
        this.cell = newCell;
      }
    },
    cell(val) {
      if (val) {
        localStorage.setItem(STORAGE_KEY, val);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }

      this.syncCellSelection(val);
    },
  },
};
</script>
